// removed by extract-text-webpack-plugin
module.exports = {"my-demand-detail":"my-demand-detail","wrap-content-need-offer":"wrap-content-need-offer","need-offer-content-black":"need-offer-content-black","need-offer-content":"need-offer-content","need-offer-content-time-wrap":"need-offer-content-time-wrap","need-offer-content-category-wrap":"need-offer-content-category-wrap","category-demand":"category-demand"};


//////////////////
// WEBPACK FOOTER
// ./components/users/my-demand-content/_MyDemandDetailContent.scss
// module id = ./components/users/my-demand-content/_MyDemandDetailContent.scss
// module chunks = 0